import { render } from "./DropDownMenu.vue?vue&type=template&id=7dc04bfc&scoped=true"
import script from "./DropDownMenu.vue?vue&type=script&lang=js"
export * from "./DropDownMenu.vue?vue&type=script&lang=js"

import "./DropDownMenu.vue?vue&type=style&index=0&id=7dc04bfc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc04bfc"]])

export default __exports__